require('../../modules/es7.object.entries');
module.exports = require('../../modules/$.core').Object.entries;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/entries.js
// module id = 424
// module chunks = 0